import { css } from "@emotion/react";

export const disabledStyles = css`
  color: #aaa !important;
  background-color: #ddd !important;
  cursor: not-allowed !important;
`;
